export enum Skip2FAOptions {
  NEVER = 0,
  ONE_DAY = 1,
  THREE_DAYS = 3,
  SEVEN_DAYS = 7,
  FOURTEEN_DAYS = 14,
  THIRTY_DAYS = 30,
  NINETY_DAYS = 90,
}

export interface Skip2FAOptionsData {
  name: string;
  value: Skip2FAOptions;
}
